// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { postCopyPath } from 'helpers/api'
import { loadingToggler } from 'redux/modules/loading'
import { errorErrorsList } from 'redux/modules/notifications'
import { addPathToProjectSummary } from 'redux/modules/projectSummary'

// NOTE - this is called on Project Summary copy path. Not on Path Details copy path.

const copyPath = pathId => dispatch => (
  dispatch(loadingToggler(
    async () => {
      try {
        const { entity } = await postCopyPath(pathId)
        await dispatch(addPathToProjectSummary(entity.pathId))
      } catch (err) {
        console.warn(err)
        dispatch(errorErrorsList(err))
      }
    })
  )
)

export default copyPath
